/* eslint-disable @typescript-eslint/tslint/config */
import React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import { useInView } from "react-intersection-observer";
import { grid } from "styled-components-grid";
import { useDarkMode } from "components/layout";

const Flex = styled.div`
  ${grid({})}
  justify-content: space-evenly;
  flex-wrap: wrap;
  align-items: center;
  @media (min-width: ${(props) => props.theme.breakpoints.sm}px) {
    margin-bottom: 1em;
  }
`;

const Icon = styled(motion.div).attrs(() => ({
  variants: {
    hidden: {
      scale: 0,
      opacity: 0,
    },
    visible: (i) => ({
      opacity: 1,
      scale: 1,
      transition: {
        delay: i * 0.2,
      },
    }),
  },
}))`
  ${grid.unit({ size: { xs: 1 / 3, sm: 1 / 3, md: 1 / 6 } })};
  padding: 0 2.5em 2.5em 2.5em;
  display: flex;
  vertical-align: middle;
  justify-content: space-evenly;
  z-index: 100;
  text-align: center;
  img {
    max-width: 40px;
  }
`;

const images = [{
    src: "/adobeexperience.svg",
    alt: "AEM",
  },
  {
    src: "/akamai.svg",
    alt: "Akamai",
  },
  {
    src: "/analytics.svg",
    alt: "Adobe Analytics",
  },
  {
    src: "/facebook.svg",
    alt: "Gacebook",
  },
  {
    src: "/google-ads.svg",
    alt: "Google Ads",
  },
  {
    src: "/google-analytics.svg",
    alt: "Google Analytics",
  },
  {
    src: "/instagram.svg",
    alt: "Instagram",
  },
  {
    src: "/jira.svg",
    alt: "Jira",
  },
  {
    src: "/linkedin.svg",
    alt: "Linkedin",
  },
  {
    src: "/photoshop.svg",
    alt: "Photoshop",
  },
  {
    src: "/salesforce.svg",
    alt: "Salesforce",
  },
  {
    src: "/slack.svg",
    alt: "Slack",
  },
];
const randomOrder = images.sort(() => Math.random() - 0.5).slice(0, 12);



const IconGrid: React.FC = () => {
  const [dark] = useDarkMode();
  const [ref, inView] = useInView({
    rootMargin: "-100px 0px",
    triggerOnce: false,
  });
  const prefix = dark ? "./icon-grid-white" : "./icon-grid-black";
  return (
    <Flex ref={ref}>
      {randomOrder.map((item: ItemJson, i: number) => (
        <Icon key={i} custom={i} animate={inView ? "visible" : "hidden"}>
          <img
            src={prefix + item.src}
            alt={item.alt}
            loading="lazy"
          />
        </Icon>
      ))}
    </Flex>
  );
};

export { IconGrid };

interface ItemJson {
  src: string;
  alt: string;
}
